module.exports = window["wc"]["wcSettings"];